<template>
  <p class="container">
    <label v-if="!hideLabel" class="a-form-label" :for="inputId">
      {{ label !== '' ? label : $t('label-address') }} <span :style="{ color: 'red' }">{{ required ? '*' : '' }}</span>
      <span v-if="isPublicInformation" class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-public-information') }}</span>
    </label>
    <gmap-autocomplete
      :class="'a-form-control' + (mapStyle ? ' map' : '')"
      :id="inputId"
      ref="addressInput"
      v-model="addressBind"
      @place_changed="setPlace"
      selectFirstOnEnter
      :placeholder="placeholder !== '' ? placeholder : $t('placeholder-address')"
    />
    <slot></slot>
  </p>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    mapStyle: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    isPublicInformation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      randomGoogleAutocompleteId: Math.random() // This is to prevent chrome from showing its native autocomplete
    }
  },
  methods: {
    setPlace: function(place) {
      this.$emit('input', place.formatted_address)
      this.$emit('place', place)
    }
  },
  mounted() {
    let _this = this
    setTimeout(function() {
      _this.$refs.addressInput.$el.setAttribute('autocomplete', 'business-address')
    }, 1000)
  },
  computed: {
    addressBind: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val.target.value)
      }
    },
    inputId: function() {
      return `gmap${this.randomGoogleAutocompleteId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  background-image: url(~@/assets/mag.svg);
  background-repeat: no-repeat;
  background-position: calc(100% - 16px) 50%;
  background-size: auto 20px;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.12);
  border: none;
  padding-right: 56px;
}

.container {
  position: relative;
}
</style>
